import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon, Label, Button } from 'semantic-ui-react'
import { createContainerAtLineLevel, removeContainerItem } from '../../actions'
import usePdiEnable from '../../hooks/usePdiEnable'

function Container(props) {
  const [isAdding, setIsAdding] = useState(false)
  const [showContainerList, setShowContainerList] = useState(false)

  const { merchandiseId, lineItemIndex, isFormDisabled, invoiceIndex, translate, invoiceId } = props
  const dispatch = useDispatch()
  const updateAddStatus = useCallback(() => {
    setIsAdding(false)
  }, [isAdding])
  const headercontainers = useSelector((state) => state.ContainerReducer.containers || [])
  const itemContainers = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[invoiceIndex].merchandiseList[lineItemIndex]?.containers
  )
  const computeContainerDopdownMerchendise = useCallback(() => {
    var containers = headercontainers.filter(
      (elem) =>
        !itemContainers.find(({ containerNumber }) => elem.containerNumber === containerNumber)
    )

    return containers
  }, [itemContainers.length,headercontainers.length])

  const pdiDisabled = usePdiEnable();

  var containers = computeContainerDopdownMerchendise() || []
  const setDisplayContainerNumbers = useCallback(
    (valueList) => {
      let list = []
      if (valueList && valueList.length > 0) {
        valueList.map((item, index) => {
          return list.push(
            <Label key={index} style={{cursor:"pointer"}}>
              {item.containerNumber}
              <Icon
                id={`deleteContainer-${index}`}
                name='delete'
                disabled={isFormDisabled}
                {...pdiDisabled}
                onClick={() => {
                  dispatch(
                    removeContainerItem(
                      invoiceIndex,
                      lineItemIndex,
                      index,
                      merchandiseId,
                      invoiceId,
                      item.containerId,
                      item.containerAssociationId
                    )
                  )
                }}
              />
            </Label>
          )
        })
      }

      return list
    },
    [itemContainers.length, headercontainers.length,showContainerList]
  )

 
  return (
    <>
      <div className='field-bg lineContainer'
      onClick={() =>  setShowContainerList(false)}
      >
        <Label className='name-label es label-no'>
          31
        </Label>
        <label className ="lineContainer-label">
          {translate("CONT_NUM",{ns:["default","lineItem"]})}
        </label>
        <span>
          <Label.Group style={{ marginLeft: '3px' }}>
            {setDisplayContainerNumbers(itemContainers)}

            <Button
            className="lineContainer-btn"
              id="addContainer"
              onClick={(e) =>{
                e.stopPropagation(); 
                setShowContainerList(true)
              }}
              disabled={isFormDisabled}
              {...pdiDisabled}
            >
              Add
            </Button>
          </Label.Group>
        </span>
        {showContainerList && containers && containers.length > 0 && (
          <div className='productHistory container-no-list'>
            {containers.map((containerItem, iii) => (
              <React.Fragment key={containerItem.containerNumber + ' ' + iii}>
                <a
                  className='dropdownlink'
                  onClick={() => {
                    dispatch(
                      createContainerAtLineLevel(
                        containerItem.containerId,
                        containerItem.containerNumber,
                        merchandiseId,
                        invoiceId,
                        invoiceIndex,
                        lineItemIndex
                      )
                    )
                    updateAddStatus()
                    setShowContainerList(false)
                  }}
                  onBlur={() => setShowContainerList(false)}
                >
                  <table className='productHistoryTable'>
                    <tbody>
                      <tr>
                        <td colSpan='2' className='displaySelcted'>
                          <span
                            style={{
                              whiteSpace: 'nowrap',
                              textTransform: 'uppercase',
                            }}
                          >
                            <h5>{containerItem.containerNumber || ''}</h5>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </a>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default React.memo(Container)
